import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { PlayContentOnDevicesDocument } from './play-content.generated';

export const usePlayContentOnDevices = (
  options: ApiOptions<typeof PlayContentOnDevicesDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(PlayContentOnDevicesDocument, {
    ...useNotifications(PlayContentOnDevicesDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        t('api.devices.play_content_success_plural', {
          count: data.playContentOnDevices?.devices.length ?? 0,
        }),
    }),
    ...options,
  });
};
